import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { DigitalHumanCanvas } from '@/features/app-shell/canvases/digital-human-canvas'

export const Route = createFileRoute('/app/tools/digital-human')({
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppToolsDigitalHumanPage,
})

function AppToolsDigitalHumanPage() {
  return (
    <AppShell activePath="/app">
      <DigitalHumanCanvas />
    </AppShell>
  )
}
